import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import {LoadFormComponent} from './load-form/load-form.component'
//import {WorkRegComponent} from './work-reg/work-reg.component'
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import {IsAuthenticatedGuard} from './is-authenticated.guard';
import {IntegratePspComponent} from './integrate-psp/integrate-psp.component';
import {IntegrateCscComponent} from './integrate-csc/integrate-csc.component';
import {ThirdPartyVerifyComponent} from './third-party-verify/third-party-verify.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { IntegrateCscCycleComponentComponent } from './integrate-csc-cycle-component/integrate-csc-cycle-component.component';

const routes: Routes = [
  { path: 'worker', loadChildren: './workers/workers.module#WorkersModule'   },//
  { path: 'inspector',loadChildren: './inspectors/inspectors.module#InspectorsModule' },
  { path: 'payment', loadChildren: './payment/payment.module#PaymentModule' },
  { path: 'cess', loadChildren: './cess/cess.module#CessModule' },
  { path: 'login',component: LoginComponent },
  { path: 'forgot',component: ForgotPasswordComponent },
  { path: 'pspintegrate/:id',component: IntegratePspComponent },
  { path: 'cscintegrate',component: IntegrateCscComponent },
  { path: 'csccycleintegrate/:id',component: IntegrateCscCycleComponentComponent },
  { path: 'third-party-verification',component: ThirdPartyVerifyComponent },
  { path: 'reports',loadChildren:'./reports/reports.module#ReportsModule'  },
  {path: 'admin', loadChildren: './admin/master/master.module#MasterModule'},
  { path: '**',redirectTo:'login'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports:[RouterModule]
})
export class AppRoutingModule { }
